import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const { saveSession } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");

    if (!sessionId) {
      toast.error("Sessione Google non trovata. Riprova.");
      navigate("/auth");
      return;
    }

    // Pulisce l'hash dall'URL immediatamente
    window.history.replaceState(null, "", window.location.pathname);

    axios.post(`${API}/api/auth/google/session`, { session_id: sessionId })
      .then(r => {
        saveSession(r.data);
        toast.success(`Bentornato, ${r.data.user.name || r.data.user.email}!`);
        navigate("/app", { replace: true });
      })
      .catch((err) => {
        const detail = err.response?.data?.detail || "Errore nel login con Google";
        toast.error(detail);
        navigate("/auth", { replace: true });
      });
  }, []);

  return (
    <div className="min-h-screen bg-[#0F172A] flex flex-col items-center justify-center gap-3">
      <div className="w-8 h-8 border-2 border-white/20 border-t-white rounded-full animate-spin" />
      <div className="text-white/60 text-sm">Accesso con Google in corso...</div>
    </div>
  );
}
